export default __webpack_public_path__ + "static/media/guide_02.efc3f1da.md";